<form
  [formGroup]="form"
  (ngSubmit)="onSubmitRegistration(form)"
  #formRef="ngForm"
  [patchForm]="valuesForm$ | async"
  [canEdit]="[accessRights.ConfigurationOptions_write]"
  [canEdit]="[accessRights.Settings_write]"
>
  <!-- Card -->
  <section class="card mb-3">
    <div class="card-header card-collapse">
      <!-- Header -->
      <h2 class="accordion-header">
        <button
          class="accordion-button"
          type="button"
          [attr.aria-expanded]="isCollapsed ? 'false' : 'true'"
          (click)="isCollapsed = !isCollapsed"
          aria-controls="registration"
        >
          <span class="fs-3">
            {{ 'general.registration' | translate }}
          </span>
          <i
            class="fa fa-fw"
            [ngClass]="isCollapsed ? 'fa-chevron-down' : 'fa-chevron-up'"
            attr.aria-label="{{ 'wcag.toggleSection' | translate }}"
            role="img"
          ></i>
        </button>
      </h2>

      <!-- End Header -->
    </div>

    <div *ngIf="!isCollapsed" class="card-body" id="registration">
      <fieldset formGroupName="firstName">
        <legend class="h4">
          {{ 'general.firstName' | translate }}
        </legend>
        <div class="row gx-2 border-bottom mb-3 pb-2">
          <div class="col-lg-4">
            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="firstNameVisible"
                checked
                formControlName="isVisible"
                (change)="onVisibleInputChange('firstName')"
              />
              <label for="firstNameVisible">{{
                'general.isVisible' | translate | titlecase
              }}</label>
            </div>

            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="firstNameRequired"
                checked
                formControlName="isRequired"
              />
              <label for="firstNameRequired">{{
                'general.isRequired' | translate | titlecase
              }}</label>
            </div>

            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="firstNameEditable"
                formControlName="isEditable"
              />
              <label for="firstNameEditable">{{
                'general.isEditable' | translate | titlecase
              }}</label>
            </div>
          </div>
          <div class="col">
            <label class="form-label" id="firstNameDescriptionLabel">{{
              'general.customDescription' | translate
            }}</label>

            <div class="row g-2">
              <div class="col-lg-6" *ngIf="availableLanguages['nl']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-nl"
                      role="img"
                      attr.aria-label="{{ 'wcag.nl' | translate }}"
                      id="flag-nl-id0"
                    ></span
                  ></span>

                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="firstNameDescriptionLabel flag-nl-id0"
                    formControlName="title_nl"
                  />
                </div>
              </div>
              <div class="col-lg-6" *ngIf="availableLanguages['en']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-en"
                      role="img"
                      attr.aria-label="{{ 'wcag.en' | translate }}"
                      id="flag-en-id0"
                    ></span
                  ></span>
                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="firstNameDescriptionLabel flag-en-id0"
                    formControlName="title_en"
                  />
                </div>
              </div>
              <div class="col-lg-6" *ngIf="availableLanguages['fr']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-fr"
                      role="img"
                      attr.aria-label="{{ 'wcag.fr' | translate }}"
                      id="flag-fr-id0"
                    ></span
                  ></span>

                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="firstNameDescriptionLabel flag-fr-id0"
                    formControlName="title_fr"
                  />
                </div>
              </div>
              <div class="col-lg-6" *ngIf="availableLanguages['de']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-de"
                      role="img"
                      attr.aria-label="{{ 'wcag.de' | translate }}"
                      id="flag-de-id0"
                    ></span
                  ></span>
                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="firstNameDescriptionLabel flag-de-id0"
                    formControlName="title_de"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </fieldset>
      <fieldset formGroupName="middleName">
        <legend class="h4">{{ 'general.middleName' | translate }}</legend>
        <div class="row gx-2 border-bottom mb-3 pb-2">
          <div class="col-lg-4">
            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="middleNameVisible"
                checked
                formControlName="isVisible"
                (change)="onVisibleInputChange('middleName')"
              />
              <label for="middleNameVisible">{{
                'general.isVisible' | translate | titlecase
              }}</label>
            </div>

            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="middleNameRequired"
                formControlName="isRequired"
              />
              <label for="middleNameRequired">{{
                'general.isRequired' | translate | titlecase
              }}</label>
            </div>

            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="middleNameEditable"
                formControlName="isEditable"
              />
              <label for="middleNameEditable">{{
                'general.isEditable' | translate | titlecase
              }}</label>
            </div>
          </div>
          <div class="col">
            <label class="form-label" id="middleNameCustomLabel">{{
              'general.customDescription' | translate
            }}</label>

            <div class="row g-2">
              <div class="col-lg-6" *ngIf="availableLanguages['nl']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-nl"
                      role="img"
                      attr.aria-label="{{ 'wcag.nl' | translate }}"
                      id="flag-nl-id28"
                    ></span
                  ></span>

                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="middleNameCustomLabel flag-nl-id28"
                    formControlName="title_nl"
                  />
                </div>
              </div>
              <div class="col-lg-6" *ngIf="availableLanguages['en']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-en"
                      role="img"
                      attr.aria-label="{{ 'wcag.en' | translate }}"
                      id="flag-en-id28"
                    ></span
                  ></span>
                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="middleNameCustomLabel flag-en-id28"
                    formControlName="title_en"
                  />
                </div>
              </div>

              <div class="col-lg-6" *ngIf="availableLanguages['fr']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-fr"
                      role="img"
                      attr.aria-label="{{ 'wcag.fr' | translate }}"
                      id="flag-fr-id28"
                    ></span
                  ></span>

                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="middleNameCustomLabel flag-fr-id28"
                    formControlName="title_fr"
                  />
                </div>
              </div>

              <div class="col-lg-6" *ngIf="availableLanguages['de']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-de"
                      role="img"
                      attr.aria-label="{{ 'wcag.de' | translate }}"
                      id="flag-de-id28"
                    ></span
                  ></span>
                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="middleNameCustomLabel flag-de-id28"
                    formControlName="title_de"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </fieldset>
      <fieldset formGroupName="lastName">
        <legend class="h4">{{ 'general.lastName' | translate }}</legend>
        <div class="row gx-2 border-bottom mb-3 pb-2">
          <div class="col-lg-4">
            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="lastNameVisible"
                checked
                formControlName="isVisible"
                (change)="onVisibleInputChange('lastName')"
              />
              <label for="lastNameVisible">{{
                'general.isVisible' | translate | titlecase
              }}</label>
            </div>
            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="lastNameRequired"
                checked
                formControlName="isRequired"
              />
              <label for="lastNameRequired">{{
                'general.isRequired' | translate | titlecase
              }}</label>
            </div>
            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="lastNameEditable"
                formControlName="isEditable"
              />
              <label for="lastNameEditable">{{
                'general.isEditable' | translate | titlecase
              }}</label>
            </div>
          </div>
          <div class="col">
            <label class="form-label" id="lastNameCustomDescLabel">{{
              'general.customDescription' | translate
            }}</label>
            <div class="row g-2">
              <div class="col-lg-6" *ngIf="availableLanguages['nl']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-nl"
                      role="img"
                      attr.aria-label="{{ 'wcag.nl' | translate }}"
                      id="flag-nl-id1"
                    ></span
                  ></span>

                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="lastNameCustomDescLabel flag-nl-id1"
                    formControlName="title_nl"
                  />
                </div>
              </div>
              <div class="col-lg-6" *ngIf="availableLanguages['en']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-en"
                      role="img"
                      attr.aria-label="{{ 'wcag.en' | translate }}"
                      id="flag-en-id1"
                    ></span
                  ></span>
                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="lastNameCustomDescLabel flag-en-id1"
                    formControlName="title_en"
                  />
                </div>
              </div>
              <div class="col-lg-6" *ngIf="availableLanguages['fr']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-fr"
                      role="img"
                      attr.aria-label="{{ 'wcag.fr' | translate }}"
                      id="flag-fr-id1"
                    ></span
                  ></span>

                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="lastNameCustomDescLabel flag-fr-id1"
                    formControlName="title_fr"
                  />
                </div>
              </div>
              <div class="col-lg-6" *ngIf="availableLanguages['de']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-de"
                      role="img"
                      attr.aria-label="{{ 'wcag.de' | translate }}"
                      id="flag-de-id1"
                    ></span
                  ></span>
                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="lastNameCustomDescLabel flag-de-id1"
                    formControlName="title_de"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </fieldset>
      <fieldset formGroupName="street">
        <legend class="h4">{{ 'general.street' | translate }}</legend>

        <div class="row gx-2 border-bottom mb-3 pb-2">
          <div class="col-lg-4">
            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="streetVisible"
                checked
                formControlName="isVisible"
                (change)="onVisibleInputChange('street')"
              />
              <label for="streetVisible">{{
                'general.isVisible' | translate | titlecase
              }}</label>
            </div>
            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="streetRequired"
                checked
                formControlName="isRequired"
              />
              <label for="streetRequired">{{
                'general.isRequired' | translate | titlecase
              }}</label>
            </div>
            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="streetEditable"
                formControlName="isEditable"
              />
              <label for="streetEditable">{{
                'general.isEditable' | translate | titlecase
              }}</label>
            </div>
          </div>
          <div class="col">
            <label class="form-label" id="streetCustomDescLabel">{{
              'general.customDescription' | translate
            }}</label>

            <div class="row g-2">
              <div class="col-lg-6" *ngIf="availableLanguages['nl']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-nl"
                      role="img"
                      attr.aria-label="{{ 'wcag.nl' | translate }}"
                      id="flag-nl-id2"
                    ></span
                  ></span>

                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="streetCustomDescLabel flag-nl-id2"
                    formControlName="title_nl"
                  />
                </div>
              </div>
              <div class="col-lg-6" *ngIf="availableLanguages['en']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-en"
                      role="img"
                      attr.aria-label="{{ 'wcag.en' | translate }}"
                      id="flag-en-id2"
                    ></span
                  ></span>
                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="streetCustomDescLabel flag-en-id2"
                    formControlName="title_en"
                  />
                </div>
              </div>
              <div class="col-lg-6" *ngIf="availableLanguages['fr']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-fr"
                      role="img"
                      attr.aria-label="{{ 'wcag.fr' | translate }}"
                      id="flag-fr-id2"
                    ></span
                  ></span>

                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="streetCustomDescLabel flag-fr-id2"
                    formControlName="title_fr"
                  />
                </div>
              </div>
              <div class="col-lg-6" *ngIf="availableLanguages['de']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-de"
                      role="img"
                      attr.aria-label="{{ 'wcag.de' | translate }}"
                      id="flag-de-id2"
                    ></span
                  ></span>
                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="streetCustomDescLabel flag-de-id2"
                    formControlName="title_de"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </fieldset>
      <fieldset formGroupName="houseNr">
        <legend class="h4">{{ 'general.houseNumber' | translate }}</legend>
        <div class="row gx-2 border-bottom mb-3 pb-2">
          <div class="col-lg-4">
            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="houseNumberVisible"
                checked
                formControlName="isVisible"
                (change)="onVisibleInputChange('houseNr')"
              />
              <label for="houseNumberVisible">{{
                'general.isVisible' | translate | titlecase
              }}</label>
            </div>
            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="houseNumberRequired"
                checked
                formControlName="isRequired"
              />
              <label for="houseNumberRequired">{{
                'general.isRequired' | translate | titlecase
              }}</label>
            </div>
            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="houseNumberEditable"
                formControlName="isEditable"
              />
              <label for="houseNumberEditable">{{
                'general.isEditable' | translate | titlecase
              }}</label>
            </div>
          </div>
          <div class="col">
            <label class="form-label" id="houseNumberCustomDescLabel">{{
              'general.customDescription' | translate
            }}</label>

            <div class="row g-2">
              <div class="col-lg-6" *ngIf="availableLanguages['nl']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-nl"
                      role="img"
                      attr.aria-label="{{ 'wcag.nl' | translate }}"
                      id="flag-nl-id3"
                    ></span
                  ></span>

                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="houseNumberCustomDescLabel flag-nl-id3"
                    formControlName="title_en"
                  />
                </div>
              </div>
              <div class="col-lg-6" *ngIf="availableLanguages['en']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-en"
                      role="img"
                      attr.aria-label="{{ 'wcag.en' | translate }}"
                      id="flag-en-id3"
                    ></span
                  ></span>
                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="houseNumberCustomDescLabel flag-en-id3"
                    formControlName="title_en"
                  />
                </div>
              </div>
              <div class="col-lg-6" *ngIf="availableLanguages['fr']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-fr"
                      role="img"
                      attr.aria-label="{{ 'wcag.fr' | translate }}"
                      id="flag-fr-id3"
                    ></span
                  ></span>

                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="houseNumberCustomDescLabel flag-fr-id3"
                    formControlName="title_fr"
                  />
                </div>
              </div>
              <div class="col-lg-6" *ngIf="availableLanguages['de']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-de"
                      role="img"
                      attr.aria-label="{{ 'wcag.de' | translate }}"
                      id="flag-de-id3"
                    ></span
                  ></span>
                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="houseNumberCustomDescLabel flag-de-id3"
                    formControlName="title_de"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </fieldset>

      <fieldset formGroupName="postbox">
        <legend class="h4">{{ 'general.postbox' | translate }}</legend>

        <div class="row gx-2 border-bottom mb-3 pb-2">
          <div class="col-lg-4">
            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="postboxVisible"
                checked
                formControlName="isVisible"
                (change)="onVisibleInputChange('postbox')"
              />
              <label for="postboxVisible">{{
                'general.isVisible' | translate | titlecase
              }}</label>
            </div>
            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="postboxRequired"
                checked
                formControlName="isRequired"
              />
              <label for="postboxRequired">{{
                'general.isRequired' | translate | titlecase
              }}</label>
            </div>
            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="postboxEditable"
                formControlName="isEditable"
              />
              <label for="postboxEditable">{{
                'general.isEditable' | translate | titlecase
              }}</label>
            </div>
          </div>
          <div class="col">
            <label class="form-label" id="postBoxCustomDescLabel">{{
              'general.customDescription' | translate
            }}</label>

            <div class="row g-2">
              <div class="col-lg-6" *ngIf="availableLanguages['nl']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-nl"
                      role="img"
                      attr.aria-label="{{ 'wcag.nl' | translate }}"
                      id="flag-nl-id4"
                    ></span
                  ></span>

                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="postBoxCustomDescLabel flag-nl-id4"
                    formControlName="title_nl"
                  />
                </div>
              </div>
              <div class="col-lg-6" *ngIf="availableLanguages['en']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-en"
                      role="img"
                      attr.aria-label="{{ 'wcag.en' | translate }}"
                      id="flag-en-id4"
                    ></span
                  ></span>
                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="postBoxCustomDescLabel flag-en-id4"
                    formControlName="title_en"
                  />
                </div>
              </div>
              <div class="col-lg-6" *ngIf="availableLanguages['fr']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-fr"
                      role="img"
                      attr.aria-label="{{ 'wcag.fr' | translate }}"
                      id="flag-fr-id4"
                    ></span
                  ></span>

                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="postBoxCustomDescLabel flag-fr-id4"
                    formControlName="title_fr"
                  />
                </div>
              </div>
              <div class="col-lg-6" *ngIf="availableLanguages['de']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-de"
                      role="img"
                      attr.aria-label="{{ 'wcag.de' | translate }}"
                      id="flag-de-id4"
                    ></span
                  ></span>
                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="postBoxCustomDescLabel flag-de-id4"
                    formControlName="title_de"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </fieldset>

      <fieldset formGroupName="zipcode">
        <legend class="h4">{{ 'general.zipcode' | translate }}</legend>

        <div class="row gx-2 border-bottom mb-3 pb-2">
          <div class="col-lg-4">
            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="zipcodeVisible"
                checked
                formControlName="isVisible"
                (change)="onVisibleInputChange('zipcode')"
              />
              <label for="zipcodeVisible">{{
                'general.isVisible' | translate | titlecase
              }}</label>
            </div>
            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="zipcodeRequired"
                checked
                formControlName="isRequired"
              />
              <label for="zipcodeRequired">{{
                'general.isRequired' | translate | titlecase
              }}</label>
            </div>
            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="zipcodeEditable"
                formControlName="isEditable"
              />
              <label for="zipcodeEditable">{{
                'general.isEditable' | translate | titlecase
              }}</label>
            </div>
          </div>
          <div class="col">
            <label class="form-label" id="zipCodeCustomDescLabel">{{
              'general.customDescription' | translate
            }}</label>

            <div class="row g-2">
              <div class="col-lg-6" *ngIf="availableLanguages['nl']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-nl"
                      role="img"
                      attr.aria-label="{{ 'wcag.nl' | translate }}"
                      id="flag-nl-id5"
                    ></span
                  ></span>

                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="zipCodeCustomDescLabel flag-nl-id5"
                    formControlName="title_nl"
                  />
                </div>
              </div>
              <div class="col-lg-6" *ngIf="availableLanguages['en']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-en"
                      role="img"
                      attr.aria-label="{{ 'wcag.en' | translate }}"
                      id="flag-en-id5"
                    ></span
                  ></span>
                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="zipCodeCustomDescLabel flag-en-id5"
                    formControlName="title_en"
                  />
                </div>
              </div>
              <div class="col-lg-6" *ngIf="availableLanguages['fr']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-fr"
                      role="img"
                      attr.aria-label="{{ 'wcag.fr' | translate }}"
                      id="flag-fr-id5"
                    ></span
                  ></span>

                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="zipCodeCustomDescLabel flag-fr-id5"
                    formControlName="title_fr"
                  />
                </div>
              </div>
              <div class="col-lg-6" *ngIf="availableLanguages['de']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-de"
                      role="img"
                      attr.aria-label="{{ 'wcag.de' | translate }}"
                      id="flag-de-id5"
                    ></span
                  ></span>
                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="zipCodeCustomDescLabel flag-de-id5"
                    formControlName="title_de"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </fieldset>

      <fieldset formGroupName="municipality">
        <legend class="h4">{{ 'general.municipality' | translate }}</legend>
        <div class="row gx-2 border-bottom mb-3 pb-2">
          <div class="col-lg-4">
            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="municipalityVisible"
                checked
                formControlName="isVisible"
                (change)="onVisibleInputChange('municipality')"
              />
              <label for="municipalityVisible">{{
                'general.isVisible' | translate | titlecase
              }}</label>
            </div>
            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="municipalityRequired"
                checked
                formControlName="isRequired"
              />
              <label for="municipalityRequired">{{
                'general.isRequired' | translate | titlecase
              }}</label>
            </div>
            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="municipalityEditable"
                formControlName="isEditable"
              />
              <label for="municipalityEditable">{{
                'general.isEditable' | translate | titlecase
              }}</label>
            </div>
          </div>
          <div class="col">
            <label class="form-label" id="municipalityCustomDescLabel">{{
              'general.customDescription' | translate
            }}</label>

            <div class="row g-2">
              <div class="col-lg-6" *ngIf="availableLanguages['nl']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-nl"
                      role="img"
                      attr.aria-label="{{ 'wcag.nl' | translate }}"
                      id="flag-nl-id6"
                    ></span
                  ></span>

                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="municipalityCustomDescLabel flag-nl-id6"
                    formControlName="title_nl"
                  />
                </div>
              </div>
              <div class="col-lg-6" *ngIf="availableLanguages['en']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-en"
                      role="img"
                      attr.aria-label="{{ 'wcag.en' | translate }}"
                      id="flag-en-id6"
                    ></span
                  ></span>
                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="municipalityCustomDescLabel flag-en-id6"
                    formControlName="title_en"
                  />
                </div>
              </div>
              <div class="col-lg-6" *ngIf="availableLanguages['fr']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-fr"
                      role="img"
                      attr.aria-label="{{ 'wcag.fr' | translate }}"
                      id="flag-fr-id6"
                    ></span
                  ></span>

                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="municipalityCustomDescLabel flag-fr-id6"
                    formControlName="title_fr"
                  />
                </div>
              </div>
              <div class="col-lg-6" *ngIf="availableLanguages['de']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-de"
                      role="img"
                      attr.aria-label="{{ 'wcag.de' | translate }}"
                      id="flag-de-id6"
                    ></span
                  ></span>
                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="municipalityCustomDescLabel flag-de-id6"
                    formControlName="title_de"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </fieldset>

      <fieldset formGroupName="city">
        <legend class="h4">{{ 'general.city' | translate }}</legend>
        <div class="row gx-2 border-bottom mb-3 pb-2">
          <div class="col-lg-4">
            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="cityVisible"
                checked
                formControlName="isVisible"
                (change)="onVisibleInputChange('city')"
              />
              <label for="cityVisible">{{
                'general.isVisible' | translate | titlecase
              }}</label>
            </div>
            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="cityRequired"
                checked
                formControlName="isRequired"
              />
              <label for="cityRequired">{{
                'general.isRequired' | translate | titlecase
              }}</label>
            </div>
            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="cityEditable"
                formControlName="isEditable"
              />
              <label for="cityEditable">{{
                'general.isEditable' | translate | titlecase
              }}</label>
            </div>
          </div>
          <div class="col">
            <label class="form-label" id="cityCustomDescLabel">{{
              'general.customDescription' | translate
            }}</label>

            <div class="row g-2">
              <div class="col-lg-6" *ngIf="availableLanguages['nl']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-nl"
                      role="img"
                      attr.aria-label="{{ 'wcag.nl' | translate }}"
                      id="flag-nl-id7"
                    ></span
                  ></span>

                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="cityCustomDescLabel flag-nl-id7"
                    formControlName="title_nl"
                  />
                </div>
              </div>
              <div class="col-lg-6" *ngIf="availableLanguages['en']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-en"
                      role="img"
                      attr.aria-label="{{ 'wcag.en' | translate }}"
                      id="flag-en-id7"
                    ></span
                  ></span>
                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="cityCustomDescLabel flag-en-id7"
                    formControlName="title_en"
                  />
                </div>
              </div>
              <div class="col-lg-6" *ngIf="availableLanguages['fr']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-fr"
                      role="img"
                      attr.aria-label="{{ 'wcag.fr' | translate }}"
                      id="flag-fr-id7"
                    ></span
                  ></span>

                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="cityCustomDescLabel flag-fr-id7"
                    formControlName="title_fr"
                  />
                </div>
              </div>
              <div class="col-lg-6" *ngIf="availableLanguages['de']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-de"
                      role="img"
                      attr.aria-label="{{ 'wcag.de' | translate }}"
                      id="flat-de-id7"
                    ></span
                  ></span>
                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="cityCustomDescLabel flag-de-id7"
                    formControlName="title_de"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </fieldset>

      <fieldset formGroupName="region">
        <legend class="h4">{{ 'general.region' | translate }}</legend>
        <div class="row gx-2 border-bottom mb-3 pb-2">
          <div class="col-lg-4">
            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="regionVisible"
                checked
                formControlName="isVisible"
                (change)="onVisibleInputChange('region')"
              />
              <label for="regionVisible">{{
                'general.isVisible' | translate | titlecase
              }}</label>
            </div>
            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="regionRequired"
                checked
                formControlName="isRequired"
              />
              <label for="regionRequired">{{
                'general.isRequired' | translate | titlecase
              }}</label>
            </div>
            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="regionEditable"
                formControlName="isEditable"
              />
              <label for="regionEditable">{{
                'general.isEditable' | translate | titlecase
              }}</label>
            </div>
          </div>
          <div class="col">
            <label class="form-label" id="regionCustomDescLabel">{{
              'general.customDescription' | translate
            }}</label>

            <div class="row g-2">
              <div class="col-lg-6" *ngIf="availableLanguages['nl']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-nl"
                      role="img"
                      attr.aria-label="{{ 'wcag.nl' | translate }}"
                      id="flag-nl-id8"
                    ></span
                  ></span>

                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="regionCustomDescLabel flag-nl-id8"
                    formControlName="title_nl"
                  />
                </div>
              </div>
              <div class="col-lg-6" *ngIf="availableLanguages['en']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-en"
                      role="img"
                      attr.aria-label="{{ 'wcag.en' | translate }}"
                      id="flag-en-id8"
                    ></span
                  ></span>
                  <input
                    type="text"
                    class="form-control"
                    aria-label=""
                    aria-labelledby="regionCustomDescLabel flag-en-id8"
                    formControlName="title_en"
                  />
                </div>
              </div>
              <div class="col-lg-6" *ngIf="availableLanguages['fr']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-fr"
                      role="img"
                      attr.aria-label="{{ 'wcag.fr' | translate }}"
                      id="flag-fr-id8"
                    ></span
                  ></span>

                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="regionCustomDescLabel flag-fr-id8"
                    formControlName="title_fr"
                  />
                </div>
              </div>
              <div class="col-lg-6" *ngIf="availableLanguages['de']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-de"
                      role="img"
                      attr.aria-label="{{ 'wcag.de' | translate }}"
                      id="flag-de-id8"
                    ></span
                  ></span>
                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="regionCustomDescLabel flag-de-id8"
                    formControlName="title_de"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </fieldset>

      <fieldset formGroupName="country">
        <legend class="h4">{{ 'general.country' | translate }}</legend>
        <div class="row gx-2 border-bottom mb-3 pb-2">
          <div class="col-lg-4">
            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="countryVisible"
                checked
                formControlName="isVisible"
                (change)="onVisibleInputChange('country')"
              />
              <label for="countryVisible">{{
                'general.isVisible' | translate | titlecase
              }}</label>
            </div>
            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="countryRequired"
                checked
                formControlName="isRequired"
              />
              <label for="countryRequired">{{
                'general.isRequired' | translate | titlecase
              }}</label>
            </div>
            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="countryEditable"
                formControlName="isEditable"
              />
              <label for="countryEditable">{{
                'general.isEditable' | translate | titlecase
              }}</label>
            </div>
          </div>
          <div class="col">
            <label class="form-label" id="countryCustomDescLabel">{{
              'general.customDescription' | translate
            }}</label>

            <div class="row g-2">
              <div class="col-lg-6" *ngIf="availableLanguages['nl']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-nl"
                      role="img"
                      attr.aria-label="{{ 'wcag.nl' | translate }}"
                      id="flag-nl-id9"
                    ></span
                  ></span>

                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="countryCustomDescLabel flag-nl-id9"
                    formControlName="title_nl"
                  />
                </div>
              </div>
              <div class="col-lg-6" *ngIf="availableLanguages['en']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-en"
                      role="img"
                      attr.aria-label="{{ 'wcag.en' | translate }}"
                      id="flag-en-id9"
                    ></span
                  ></span>
                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="countryCustomDescLabel flag-en-id9"
                    formControlName="title_en"
                  />
                </div>
              </div>
              <div class="col-lg-6" *ngIf="availableLanguages['fr']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-fr"
                      role="img"
                      attr.aria-label="{{ 'wcag.fr' | translate }}"
                      id="flag-fr-id9"
                    ></span
                  ></span>

                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="countryCustomDescLabel flag-fr-id9"
                    formControlName="title_fr"
                  />
                </div>
              </div>
              <div class="col-lg-6" *ngIf="availableLanguages['de']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-de"
                      role="img"
                      attr.aria-label="{{ 'wcag.de' | translate }}"
                      id="flag-de-id9"
                    ></span
                  ></span>
                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="countryCustomDescLabel flag-de-id9"
                    formControlName="title_de"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </fieldset>

      <fieldset formGroupName="phone">
        <legend class="h4">{{ 'general.phoneNumber' | translate }}</legend>

        <div class="row gx-2 border-bottom mb-3 pb-2">
          <div class="col-lg-4">
            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="phoneNumberVisible"
                checked
                formControlName="isVisible"
                (change)="onVisibleInputChange('phone')"
              />
              <label for="phoneNumberVisible">{{
                'general.isVisible' | translate | titlecase
              }}</label>
            </div>
            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="phoneNumberRequired"
                checked
                formControlName="isRequired"
              />
              <label for="phoneNumberRequired">{{
                'general.isRequired' | translate | titlecase
              }}</label>
            </div>
            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="phoneNumberEditable"
                formControlName="isEditable"
              />
              <label for="phoneNumberEditable">{{
                'general.isEditable' | translate | titlecase
              }}</label>
            </div>
          </div>
          <div class="col">
            <label class="form-label" id="phoneCustomDescLabel">{{
              'general.customDescription' | translate
            }}</label>

            <div class="row g-2">
              <div class="col-lg-6" *ngIf="availableLanguages['nl']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-nl"
                      role="img"
                      attr.aria-label="{{ 'wcag.nl' | translate }}"
                      id="flag-nl-id10"
                    ></span
                  ></span>

                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="phoneCustomDescLabel flag-nl-id10"
                    formControlName="title_nl"
                  />
                </div>
              </div>
              <div class="col-lg-6" *ngIf="availableLanguages['en']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-en"
                      role="img"
                      attr.aria-label="{{ 'wcag.en' | translate }}"
                      id="flag-en-id10"
                    ></span
                  ></span>
                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="phoneCustomDescLabel flag-en-id10"
                    formControlName="title_en"
                  />
                </div>
              </div>
              <div class="col-lg-6" *ngIf="availableLanguages['fr']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-fr"
                      role="img"
                      attr.aria-label="{{ 'wcag.fr' | translate }}"
                      id="flag-fr-id10"
                    ></span
                  ></span>

                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="phoneCustomDescLabel flag-fr-id10"
                    formControlName="title_fr"
                  />
                </div>
              </div>
              <div class="col-lg-6" *ngIf="availableLanguages['de']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-de"
                      role="img"
                      attr.aria-label="{{ 'wcag.de' | translate }}"
                      id="flag-de-id10"
                    ></span
                  ></span>
                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="phoneCustomDescLabel flag-de-id10"
                    formControlName="title_de"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </fieldset>

      <fieldset formGroupName="mobile">
        <legend class="h4">{{ 'general.mobile' | translate }}</legend>
        <div class="row gx-2 border-bottom mb-3 pb-2">
          <div class="col-lg-4">
            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="mobileNumberVisible"
                checked
                formControlName="isVisible"
                (change)="onVisibleInputChange('mobile')"
              />
              <label for="mobileNumberVisible">{{
                'general.isVisible' | translate | titlecase
              }}</label>
            </div>
            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="mobileNumberRequired"
                checked
                formControlName="isRequired"
              />
              <label for="mobileNumberRequired">{{
                'general.isRequired' | translate | titlecase
              }}</label>
            </div>
            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="mobileNumberEditable"
                formControlName="isEditable"
              />
              <label for="mobileNumberEditable">{{
                'general.isEditable' | translate | titlecase
              }}</label>
            </div>
          </div>
          <div class="col">
            <label class="form-label" id="mobileCustomDescLabel">{{
              'general.customDescription' | translate
            }}</label>

            <div class="row g-2">
              <div class="col-lg-6" *ngIf="availableLanguages['nl']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-nl"
                      role="img"
                      attr.aria-label="{{ 'wcag.nl' | translate }}"
                      id="flag-nl-id11"
                    ></span
                  ></span>

                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="mobileCustomDescLabel flag-nl-id11"
                    formControlName="title_nl"
                  />
                </div>
              </div>
              <div class="col-lg-6" *ngIf="availableLanguages['en']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-en"
                      role="img"
                      attr.aria-label="{{ 'wcag.en' | translate }}"
                      id="flag-en-id11"
                    ></span
                  ></span>
                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="mobileCustomDescLabel flag-en-id11"
                    formControlName="title_en"
                  />
                </div>
              </div>
              <div class="col-lg-6" *ngIf="availableLanguages['fr']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-fr"
                      role="img"
                      attr.aria-label="{{ 'wcag.fr' | translate }}"
                      id="flag-fr-id11"
                    ></span
                  ></span>

                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="mobileCustomDescLabel flag-fr-id11"
                    formControlName="title_fr"
                  />
                </div>
              </div>
              <div class="col-lg-6" *ngIf="availableLanguages['de']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-de"
                      role="img"
                      attr.aria-label="{{ 'wcag.de' | translate }}"
                      id="flag-de-id11"
                    ></span
                  ></span>
                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="mobileCustomDescLabel flag-de-id11"
                    formControlName="title_de"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </fieldset>

      <fieldset formGroupName="gender">
        <legend class="h4">{{ 'general.gender' | translate }}</legend>
        <div class="row gx-2 border-bottom mb-3 pb-2">
          <div class="col-lg-4">
            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="genderVisible"
                checked
                formControlName="isVisible"
                (change)="onVisibleInputChange('gender')"
              />
              <label for="genderVisible">{{
                'general.isVisible' | translate | titlecase
              }}</label>
            </div>
            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="genderRequired"
                checked
                formControlName="isRequired"
              />
              <label for="genderRequired">{{
                'general.isRequired' | translate | titlecase
              }}</label>
            </div>
            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="genderEditable"
                formControlName="isEditable"
              />
              <label for="genderEditable">{{
                'general.isEditable' | translate | titlecase
              }}</label>
            </div>
          </div>
          <div class="col">
            <label class="form-label" id="genderCustomDescLabel">{{
              'general.customDescription' | translate
            }}</label>

            <div class="row g-2">
              <div class="col-lg-6" *ngIf="availableLanguages['nl']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-nl"
                      role="img"
                      attr.aria-label="{{ 'wcag.nl' | translate }}"
                      id="flag-nl-id12"
                    ></span
                  ></span>

                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="genderCustomDescLabel flag-nl-id12"
                    formControlName="title_nl"
                  />
                </div>
              </div>
              <div class="col-lg-6" *ngIf="availableLanguages['en']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-en"
                      role="img"
                      attr.aria-label="{{ 'wcag.en' | translate }}"
                      id="flag-en-id12"
                    ></span
                  ></span>
                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="genderCustomDescLabel flag-en-id12"
                    formControlName="title_en"
                  />
                </div>
              </div>
              <div class="col-lg-6" *ngIf="availableLanguages['fr']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-fr"
                      role="img"
                      attr.aria-label="{{ 'wcag.fr' | translate }}"
                      id="flag-fr-id12"
                    ></span
                  ></span>

                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="genderCustomDescLabel flag-fr-id12"
                    formControlName="title_fr"
                  />
                </div>
              </div>
              <div class="col-lg-6" *ngIf="availableLanguages['de']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-de"
                      role="img"
                      attr.aria-label="{{ 'wcag.de' | translate }}"
                      id="flag-de-id12"
                    ></span
                  ></span>
                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="genderCustomDescLabel flag-de-id12"
                    formControlName="title_de"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </fieldset>
      <fieldset formGroupName="birthDate">
        <legend class="h4">{{ 'general.birthDate' | translate }}</legend>
        <div class="row gx-2 border-bottom mb-3 pb-2">
          <div class="col-lg-4">
            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="birthDateVisible"
                checked
                formControlName="isVisible"
                (change)="onVisibleInputChange('birthDate')"
              />
              <label for="birthDateVisible">{{
                'general.isVisible' | translate | titlecase
              }}</label>
            </div>
            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="birthDateRequired"
                checked
                formControlName="isRequired"
              />
              <label for="birthDateRequired">{{
                'general.isRequired' | translate | titlecase
              }}</label>
            </div>
            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="birthDateEditable"
                formControlName="isEditable"
              />
              <label for="birthDateEditable">{{
                'general.isEditable' | translate | titlecase
              }}</label>
            </div>
          </div>

          <div class="col">
            <label class="form-label" id="birthDateCustomDescLabel">{{
              'general.customDescription' | translate
            }}</label>

            <div class="row g-2">
              <div class="col-lg-6" *ngIf="availableLanguages['nl']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-nl"
                      role="img"
                      attr.aria-label="{{ 'wcag.nl' | translate }}"
                      id="flag-nl-id13"
                    ></span
                  ></span>

                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="birthDateCustomDescLabel flag-nl-id13"
                    formControlName="title_nl"
                  />
                </div>
              </div>
              <div class="col-lg-6" *ngIf="availableLanguages['en']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-en"
                      role="img"
                      attr.aria-label="{{ 'wcag.en' | translate }}"
                      id="flag-en-id13"
                    ></span
                  ></span>
                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="birthDateCustomDescLabel flag-en-id13"
                    formControlName="title_en"
                  />
                </div>
              </div>
              <div class="col-lg-6" *ngIf="availableLanguages['fr']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-fr"
                      role="img"
                      attr.aria-label="{{ 'wcag.fr' | translate }}"
                      id="flag-fr-id13"
                    ></span
                  ></span>

                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="birthDateCustomDescLabel flag-fr-id13"
                    formControlName="title_fr"
                  />
                </div>
              </div>
              <div class="col-lg-6" *ngIf="availableLanguages['de']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-de"
                      role="img"
                      attr.aria-label="{{ 'wcag.de' | translate }}"
                      id="flag-de-id13"
                    ></span
                  ></span>
                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="birthDateCustomDescLabel flag-de-id13"
                    formControlName="title_de"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </fieldset>

      <fieldset formGroupName="language">
        <legend class="h4">{{ 'general.language' | translate }}</legend>
        <div class="row gx-2 border-bottom mb-3 pb-2">
          <div class="col-lg-4">
            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="languageVisible"
                checked
                formControlName="isVisible"
                (change)="onVisibleInputChange('language')"
              />
              <label for="languageVisible">{{
                'general.isVisible' | translate | titlecase
              }}</label>
            </div>
            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="languageRequired"
                checked
                formControlName="isRequired"
              />
              <label for="languageRequired">{{
                'general.isRequired' | translate | titlecase
              }}</label>
            </div>
            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="languageEditable"
                formControlName="isEditable"
              />
              <label for="languageEditable">{{
                'general.isEditable' | translate | titlecase
              }}</label>
            </div>
          </div>
          <div class="col">
            <label class="form-label" id="languageCustomDescLabel">{{
              'general.customDescription' | translate
            }}</label>

            <div class="row g-2">
              <div class="col-lg-6" *ngIf="availableLanguages['nl']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-nl"
                      role="img"
                      attr.aria-label="{{ 'wcag.nl' | translate }}"
                      id="flag-nl-id14"
                    ></span
                  ></span>

                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="languageCustomDescLabel flag-nl-id14"
                    formControlName="title_nl"
                  />
                </div>
              </div>
              <div class="col-lg-6" *ngIf="availableLanguages['en']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-en"
                      role="img"
                      attr.aria-label="{{ 'wcag.en' | translate }}"
                      id="flag-en-id14"
                    ></span
                  ></span>
                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="languageCustomDescLabel flag-en-id14"
                    formControlName="title_en"
                  />
                </div>
              </div>
              <div class="col-lg-6" *ngIf="availableLanguages['fr']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-fr"
                      role="img"
                      attr.aria-label="{{ 'wcag.fr' | translate }}"
                      id="flag-fr-id14"
                    ></span
                  ></span>

                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="languageCustomDescLabel flag-fr-id14"
                    formControlName="title_fr"
                  />
                </div>
              </div>
              <div class="col-lg-6" *ngIf="availableLanguages['de']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-de"
                      role="img"
                      attr.aria-label="{{ 'wcag.de' | translate }}"
                      id="flag-de-id14"
                    ></span
                  ></span>
                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="languageCustomDescLabel flag-de-id14"
                    formControlName="title_de"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </fieldset>

      <fieldset formGroupName="shouldSync">
        <legend class="h4">{{ 'general.shouldSync' | translate }}</legend>
        <div class="row gx-2 border-bottom mb-3 pb-2">
          <div class="col-lg-4">
            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="shouldSyncVisible"
                checked
                formControlName="isVisible"
                (change)="onVisibleInputChange('shouldSync')"
              />
              <label for="shouldSyncVisible">{{
                'general.isVisible' | translate | titlecase
              }}</label>
            </div>
            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="shouldSyncRequired"
                checked
                formControlName="isRequired"
              />
              <label for="shouldSyncRequired">{{
                'general.isRequired' | translate | titlecase
              }}</label>
            </div>
            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="shouldSyncEditable"
                formControlName="isEditable"
              />
              <label for="shouldSyncEditable">{{
                'general.isEditable' | translate | titlecase
              }}</label>
            </div>
          </div>

          <div class="col">
            <label class="form-label" id="shouldSyncCustomDescLabel">{{
              'general.customDescription' | translate
            }}</label>

            <div class="row g-2">
              <div class="col-lg-6" *ngIf="availableLanguages['nl']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-nl"
                      role="img"
                      attr.aria-label="{{ 'wcag.nl' | translate }}"
                      id="flag-nl-id15"
                    ></span
                  ></span>

                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="shouldSyncCustomDescLabel flag-nl-id15"
                    formControlName="title_nl"
                  />
                </div>
              </div>
              <div class="col-lg-6" *ngIf="availableLanguages['en']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-en"
                      role="img"
                      attr.aria-label="{{ 'wcag.en' | translate }}"
                      id="flag-en-id15"
                    ></span
                  ></span>
                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="shouldSyncCustomDescLabel flag-en-id15"
                    formControlName="title_en"
                  />
                </div>
              </div>
              <div class="col-lg-6" *ngIf="availableLanguages['fr']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-fr"
                      role="img"
                      attr.aria-label="{{ 'wcag.fr' | translate }}"
                      id="flag-fr-id15"
                    ></span
                  ></span>

                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="shouldSyncCustomDescLabel flag-fr-id15"
                    formControlName="title_fr"
                  />
                </div>
              </div>
              <div class="col-lg-6" *ngIf="availableLanguages['de']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-de"
                      role="img"
                      attr.aria-label="{{ 'wcag.de' | translate }}"
                      id="flag-de-id15"
                    ></span
                  ></span>
                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="shouldSyncCustomDescLabel flag-de-id15"
                    formControlName="title_de"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </fieldset>
      <fieldset formGroupName="category">
        <legend class="h4">{{ 'general.category' | translate }}</legend>
        <div class="row gx-2 border-bottom mb-3 pb-2">
          <div class="col-lg-4">
            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="categoryVisible"
                checked
                formControlName="isVisible"
                (change)="onVisibleInputChange('category')"
              />
              <label for="categoryVisible">{{
                'general.isVisible' | translate | titlecase
              }}</label>
            </div>
            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="categoryRequired"
                checked
                formControlName="isRequired"
              />
              <label for="categoryRequired">{{
                'general.isRequired' | translate | titlecase
              }}</label>
            </div>
            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="categoryEditable"
                formControlName="isEditable"
              />
              <label for="categoryEditable">{{
                'general.isEditable' | translate | titlecase
              }}</label>
            </div>
          </div>
          <div class="col">
            <label class="form-label" id="categoryCustomDescLabel">{{
              'general.customDescription' | translate
            }}</label>

            <div class="row g-2">
              <div class="col-lg-6" *ngIf="availableLanguages['nl']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-nl"
                      role="img"
                      attr.aria-label="{{ 'wcag.nl' | translate }}"
                      id="flag-nl-id16"
                    ></span
                  ></span>

                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="categoryCustomDescLabel flag-nl-id16"
                    formControlName="title_nl"
                  />
                </div>
              </div>
              <div class="col-lg-6" *ngIf="availableLanguages['en']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-en"
                      role="img"
                      attr.aria-label="{{ 'wcag.en' | translate }}"
                      id="flag-en-id16"
                    ></span
                  ></span>
                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="categoryCustomDescLabel flag-en-id16"
                    formControlName="title_en"
                  />
                </div>
              </div>
              <div class="col-lg-6" *ngIf="availableLanguages['fr']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-fr"
                      role="img"
                      attr.aria-label="{{ 'wcag.fr' | translate }}"
                      id="flag-fr-id16"
                    ></span
                  ></span>

                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="categoryCustomDescLabel flag-fr-id16"
                    formControlName="title_fr"
                  />
                </div>
              </div>
              <div class="col-lg-6" *ngIf="availableLanguages['de']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-de"
                      role="img"
                      attr.aria-label="{{ 'wcag.de' | translate }}"
                      id="flag-de-id16"
                    ></span
                  ></span>
                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="categoryCustomDescLabel flag-de-id16"
                    formControlName="title_de"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </fieldset>
      <fieldset formGroupName="memberNumber">
        <legend class="h4">{{
          'general.studentEmployeeNumber' | translate
        }}</legend>
        <div class="row gx-2 border-bottom mb-3 pb-2">
          <div class="col-lg-4">
            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="memberNumberVisible"
                checked
                formControlName="isVisible"
                (change)="onVisibleInputChange('memberNumber')"
              />
              <label for="memberNumberVisible">{{
                'general.isVisible' | translate | titlecase
              }}</label>
            </div>
            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="memberNumberRequired"
                checked
                formControlName="isRequired"
              />
              <label for="memberNumberRequired">{{
                'general.isRequired' | translate | titlecase
              }}</label>
            </div>
            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="memberNumberEditable"
                formControlName="isEditable"
              />
              <label for="memberNumberEditable">{{
                'general.isEditable' | translate | titlecase
              }}</label>
            </div>
          </div>
          <div class="col">
            <label class="form-label" id="memberNoCustomDescLabel">{{
              'general.customDescription' | translate
            }}</label>

            <div class="row g-2">
              <div class="col-lg-6" *ngIf="availableLanguages['nl']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-nl"
                      role="img"
                      attr.aria-label="{{ 'wcag.nl' | translate }}"
                      id="flag-nl-id17"
                    ></span
                  ></span>

                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="memberNoCustomDescLabel flag-nl-id17"
                    formControlName="title_nl"
                  />
                </div>
              </div>
              <div class="col-lg-6" *ngIf="availableLanguages['en']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-en"
                      role="img"
                      attr.aria-label="{{ 'wcag.en' | translate }}"
                      id="flag-en-id17"
                    ></span
                  ></span>
                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="memberNoCustomDescLabel flag-en-id17"
                    formControlName="title_en"
                  />
                </div>
              </div>
              <div class="col-lg-6" *ngIf="availableLanguages['fr']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-fr"
                      role="img"
                      attr.aria-label="{{ 'wcag.fr' | translate }}"
                      id="flag-fr-id17"
                    ></span
                  ></span>

                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="memberNoCustomDescLabel flag-fr-id17"
                    formControlName="title_fr"
                  />
                </div>
              </div>
              <div class="col-lg-6" *ngIf="availableLanguages['de']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-de"
                      role="img"
                      attr.aria-label="{{ 'wcag.de' | translate }}"
                      id="flag-de-id17"
                    ></span
                  ></span>
                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="memberNoCustomDescLabel flag-de-id17"
                    formControlName="title_de"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </fieldset>
      <fieldset formGroupName="email">
        <legend class="h4">{{ 'general.email' | translate }}</legend>
        <div class="row gx-2 border-bottom mb-3 pb-2">
          <div class="col-lg-4">
            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="emailVisible"
                checked
                formControlName="isVisible"
                (change)="onVisibleInputChange('email')"
              />
              <label for="emailVisible">{{
                'general.isVisible' | translate | titlecase
              }}</label>
            </div>
            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="emailRequired"
                checked
                formControlName="isRequired"
              />
              <label for="emailRequired">{{
                'general.isRequired' | translate | titlecase
              }}</label>
            </div>
            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="emailEditable"
                formControlName="isEditable"
              />
              <label for="emailEditable">{{
                'general.isEditable' | translate | titlecase
              }}</label>
            </div>
          </div>
          <div class="col">
            <label class="form-label" id="emailCustomLabel">{{
              'general.customDescription' | translate
            }}</label>
            <div class="row g-2">
              <div class="col-lg-6" *ngIf="availableLanguages['nl']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-nl"
                      role="img"
                      attr.aria-label="{{ 'wcag.nl' | translate }}"
                      id="flag-nl-id18"
                    ></span
                  ></span>

                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="emailCustomLabel flag-nl-id18"
                    formControlName="title_nl"
                  />
                </div>
              </div>
              <div class="col-lg-6" *ngIf="availableLanguages['en']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-en"
                      role="img"
                      attr.aria-label="{{ 'wcag.en' | translate }}"
                      id="flag-en-id18"
                    ></span
                  ></span>
                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="emailCustomLabel flag-en-id18"
                    formControlName="title_en"
                  />
                </div>
              </div>
              <div class="col-lg-6" *ngIf="availableLanguages['fr']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-fr"
                      role="img"
                      attr.aria-label="{{ 'wcag.fr' | translate }}"
                      id="flag-fr-id18"
                    ></span
                  ></span>

                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="emailCustomLabel flag-fr-id18"
                    formControlName="title_fr"
                  />
                </div>
              </div>
              <div class="col-lg-6" *ngIf="availableLanguages['de']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-de"
                      role="img"
                      attr.aria-label="{{ 'wcag.de' | translate }}"
                      id="flag-de-id18"
                    ></span
                  ></span>
                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="emailCustomLabel flag-de-id18"
                    formControlName="title_de"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </fieldset>
      <fieldset formGroupName="password">
        <legend class="h4">{{ 'general.password' | translate }}</legend>

        <div class="row gx-2 border-bottom mb-3 pb-2">
          <div class="col-lg-4">
            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="passwordVisible"
                checked
                formControlName="isVisible"
                (change)="onVisibleInputChange('password')"
              />
              <label for="passwordVisible">{{
                'general.isVisible' | translate | titlecase
              }}</label>
            </div>
            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="passwordRequired"
                checked
                formControlName="isRequired"
              />
              <label for="passwordRequired">{{
                'general.isRequired' | translate | titlecase
              }}</label>
            </div>
            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="passwordEditable"
                formControlName="isEditable"
              />
              <label for="passwordEditable">{{
                'general.isEditable' | translate | titlecase
              }}</label>
            </div>
          </div>
          <div class="col">
            <label class="form-label" id="passwordCustomLabel">{{
              'general.customDescription' | translate
            }}</label>

            <div class="row g-2">
              <div class="col-lg-6" *ngIf="availableLanguages['nl']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-nl"
                      role="img"
                      attr.aria-label="{{ 'wcag.nl' | translate }}"
                      id="flag-nl-id19"
                    ></span
                  ></span>

                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="passwordCustomLabel flag-nl-id19"
                    formControlName="title_nl"
                  />
                </div>
              </div>
              <div class="col-lg-6" *ngIf="availableLanguages['en']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-en"
                      role="img"
                      attr.aria-label="{{ 'wcag.en' | translate }}"
                      id="flag-en-id19"
                    ></span
                  ></span>
                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="passwordCustomLabel flag-en-id19"
                    formControlName="title_en"
                  />
                </div>
              </div>
              <div class="col-lg-6" *ngIf="availableLanguages['fr']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-fr"
                      role="img"
                      attr.aria-label="{{ 'wcag.fr' | translate }}"
                      id="flag-fr-id19"
                    ></span
                  ></span>

                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="passwordCustomLabel flag-fr-id19"
                    formControlName="title_fr"
                  />
                </div>
              </div>
              <div class="col-lg-6" *ngIf="availableLanguages['de']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-de"
                      role="img"
                      attr.aria-label="{{ 'wcag.de' | translate }}"
                      id="flag-de-id19"
                    ></span
                  ></span>
                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="passwordCustomLabel flag-de-id19"
                    formControlName="title_de"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </fieldset>
      <fieldset formGroupName="passwordRepeat">
        <legend class="h4">{{ 'general.repeatPassword' | translate }}</legend>

        <div class="row gx-2 border-bottom mb-3 pb-2">
          <div class="col-lg-4">
            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="passwordRepeatVisible"
                checked
                formControlName="isVisible"
                (change)="onVisibleInputChange('passwordRepeat')"
              />
              <label for="passwordRepeatVisible">{{
                'general.isVisible' | translate | titlecase
              }}</label>
            </div>
            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="passwordRepeatRequired"
                checked
                formControlName="isRequired"
              />
              <label for="passwordRepeatRequired">{{
                'general.isRequired' | translate | titlecase
              }}</label>
            </div>
            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="passwordRepeatEditable"
                formControlName="isEditable"
              />
              <label for="passwordRepeatEditable">{{
                'general.isEditable' | translate | titlecase
              }}</label>
            </div>
          </div>
          <div class="col">
            <label class="form-label" id="repeatPasswordCustom">{{
              'general.customDescription' | translate
            }}</label>

            <div class="row g-2">
              <div class="col-lg-6" *ngIf="availableLanguages['nl']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-nl"
                      role="img"
                      attr.aria-label="{{ 'wcag.nl' | translate }}"
                      id="flat-nl-id20"
                    ></span
                  ></span>

                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="repeatPasswordCustom flag-nl-id20"
                    formControlName="title_nl"
                  />
                </div>
              </div>
              <div class="col-lg-6" *ngIf="availableLanguages['en']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-en"
                      role="img"
                      attr.aria-label="{{ 'wcag.en' | translate }}"
                      id="flag-en-id20"
                    ></span
                  ></span>
                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="repeatPasswordCustom flag-en-id20"
                    formControlName="title_en"
                  />
                </div>
              </div>
              <div class="col-lg-6" *ngIf="availableLanguages['fr']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-fr"
                      role="img"
                      attr.aria-label="{{ 'wcag.fr' | translate }}"
                      id="flag-fr-id20"
                    ></span
                  ></span>

                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="repeatPasswordCustom flag-fr-id20"
                    formControlName="title_fr"
                  />
                </div>
              </div>
              <div class="col-lg-6" *ngIf="availableLanguages['de']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-de"
                      role="img"
                      attr.aria-label="{{ 'wcag.de' | translate }}"
                      id="flag-de-id20"
                    ></span
                  ></span>
                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="repeatPasswordCustom flag-de-id20"
                    formControlName="title_de"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </fieldset>

      <fieldset formGroupName="organizationId">
        <legend class="h4">{{
          'organizationModule.organization' | translate
        }}</legend>
        <div class="row gx-2 border-bottom mb-3 pb-2">
          <div class="col-lg-4">
            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="organizationIdVisible"
                checked
                formControlName="isVisible"
                (change)="onVisibleInputChange('organizationId')"
              />
              <label for="organizationIdVisible">{{
                'general.isVisible' | translate | titlecase
              }}</label>
            </div>
            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="organizationIdRequired"
                checked
                formControlName="isRequired"
              />
              <label for="organizationIdRequired">{{
                'general.isRequired' | translate | titlecase
              }}</label>
            </div>
            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="organizationIdEditable"
                formControlName="isEditable"
              />
              <label for="organizationIdEditable">{{
                'general.isEditable' | translate | titlecase
              }}</label>
            </div>
          </div>
          <div class="col">
            <label class="form-label" id="organizationIdCustom">{{
              'general.customDescription' | translate
            }}</label>

            <div class="row g-2">
              <div class="col-lg-6" *ngIf="availableLanguages['nl']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-nl"
                      role="img"
                      attr.aria-label="{{ 'wcag.nl' | translate }}"
                      id="flag-nl-id21"
                    ></span
                  ></span>

                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="organizationIdCustom flag-nl-id21"
                    formControlName="title_nl"
                  />
                </div>
              </div>
              <div class="col-lg-6" *ngIf="availableLanguages['en']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-en"
                      role="img"
                      attr.aria-label="{{ 'wcag.en' | translate }}"
                      id="flag-en-id21"
                    ></span
                  ></span>
                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="organizationIdCustom flag-en-id21"
                    formControlName="title_en"
                  />
                </div>
              </div>
              <div class="col-lg-6" *ngIf="availableLanguages['fr']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-fr"
                      role="img"
                      attr.aria-label="{{ 'wcag.fr' | translate }}"
                      id="flag-fr-id21"
                    ></span
                  ></span>

                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="organizationIdCustom flag-fr-id21"
                    formControlName="title_fr"
                  />
                </div>
              </div>
              <div class="col-lg-6" *ngIf="availableLanguages['de']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-de"
                      role="img"
                      attr.aria-label="{{ 'wcag.de' | translate }}"
                      id="flag-de-id21"
                    ></span
                  ></span>
                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="organizationIdCustom flag-de-id21"
                    formControlName="title_de"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </fieldset>

      <fieldset formGroupName="generalTerms">
        <legend class="h4">{{ 'general.generalTerms' | translate }}</legend>

        <div class="row gx-2 border-bottom mb-3 pb-2">
          <div class="col-lg-4">
            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="generalTermsVisible"
                checked
                formControlName="isVisible"
                (change)="onVisibleInputChange('generalTerms')"
              />
              <label for="generalTermsVisible">{{
                'general.isVisible' | translate | titlecase
              }}</label>
            </div>
            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="generalTermsRequired"
                checked
                formControlName="isRequired"
              />
              <label for="generalTermsRequired">{{
                'general.isRequired' | translate | titlecase
              }}</label>
            </div>
            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="generalTermsEditable"
                formControlName="isEditable"
              />
              <label for="generalTermsEditable">{{
                'general.isEditable' | translate | titlecase
              }}</label>
            </div>
          </div>
          <div class="col">
            <label class="form-label" id="generalTermsCustom">{{
              'general.customDescription' | translate
            }}</label>

            <div class="row g-2">
              <div class="col-lg-6" *ngIf="availableLanguages['nl']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-nl"
                      role="img"
                      attr.aria-label="{{ 'wcag.nl' | translate }}"
                      id="flag-nl-id22"
                    ></span
                  ></span>

                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="generalTermsCustom flag-nl-id22"
                    formControlName="title_nl"
                  />
                </div>
              </div>
              <div class="col-lg-6" *ngIf="availableLanguages['en']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-en"
                      role="img"
                      attr.aria-label="{{ 'wcag.en' | translate }}"
                      id="flag-en-id22"
                    ></span
                  ></span>
                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="generalTermsCustom flag-en-id22"
                    formControlName="title_en"
                  />
                </div>
              </div>
              <div class="col-lg-6" *ngIf="availableLanguages['fr']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-fr"
                      role="img"
                      attr.aria-label="{{ 'wcag.fr' | translate }}"
                      id="flag-fr-id22"
                    ></span
                  ></span>

                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="generalTermsCustom flag-fr-id22"
                    formControlName="title_fr"
                  />
                </div>
              </div>
              <div class="col-lg-6" *ngIf="availableLanguages['de']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-de"
                      role="img"
                      attr.aria-label="{{ 'wcag.de' | translate }}"
                      id="flag-de-id22"
                    ></span
                  ></span>
                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="generalTermsCustom flag-de-id22"
                    formControlName="title_de"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </fieldset>
      <fieldset formGroupName="privacyTerms">
        <legend class="h4">{{ 'general.privacyTerms' | translate }}</legend>
        <div class="row gx-2 border-bottom mb-3 pb-2">
          <div class="col-lg-4">
            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="privacyTermsVisible"
                checked
                formControlName="isVisible"
                (change)="onVisibleInputChange('privacyTerms')"
              />
              <label for="privacyTermsVisible">{{
                'general.isVisible' | translate | titlecase
              }}</label>
            </div>
            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="privacyTermsRequired"
                checked
                formControlName="isRequired"
              />
              <label for="privacyTermsRequired">{{
                'general.isRequired' | translate | titlecase
              }}</label>
            </div>
            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="privacyTermsEditable"
                formControlName="isEditable"
              />
              <label for="privacyTermsEditable">{{
                'general.isEditable' | translate | titlecase
              }}</label>
            </div>
          </div>
          <div class="col">
            <label class="form-label" id="privacyTermsCustom">{{
              'general.customDescription' | translate
            }}</label>

            <div class="row g-2">
              <div class="col-lg-6" *ngIf="availableLanguages['nl']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-nl"
                      role="img"
                      attr.aria-label="{{ 'wcag.nl' | translate }}"
                      id="flag-nl-id23"
                    ></span
                  ></span>

                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="privacyTermsCustom flag-nl-id23"
                    formControlName="title_nl"
                  />
                </div>
              </div>

              <div class="col-lg-6" *ngIf="availableLanguages['en']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-en"
                      role="img"
                      attr.aria-label="{{ 'wcag.en' | translate }}"
                      id="flag-en-id23"
                    ></span
                  ></span>
                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="privacyTermsCustom flag-en-id23"
                    formControlName="title_en"
                  />
                </div>
              </div>

              <div class="col-lg-6" *ngIf="availableLanguages['fr']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-fr"
                      role="img"
                      attr.aria-label="{{ 'wcag.fr' | translate }}"
                      id="flag-fr-id23"
                    ></span
                  ></span>

                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="privacyTermsCustom flag-fr-id23"
                    formControlName="title_fr"
                  />
                </div>
              </div>
              <div class="col-lg-6" *ngIf="availableLanguages['de']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-de"
                      role="img"
                      attr.aria-label="{{ 'wcag.de' | translate }}"
                      id="flag-de-id23"
                    ></span
                  ></span>
                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="privacyTermsCustom flag-de-id23"
                    formControlName="title_de"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </fieldset>
      <fieldset formGroupName="biometricTerms">
        <legend class="h4">{{ 'general.bioMetricTerms' | translate }}</legend>

        <div class="row gx-2 border-bottom mb-3 pb-2">
          <div class="col-lg-4">
            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="biometricTermsVisible"
                checked
                formControlName="isVisible"
                (change)="onVisibleInputChange('biometricTerms')"
              />
              <label for="biometricTermsVisible">{{
                'general.isVisible' | translate | titlecase
              }}</label>
            </div>
            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="biometricTermsRequired"
                checked
                formControlName="isRequired"
              />
              <label for="biometricTermsRequired">{{
                'general.isRequired' | translate | titlecase
              }}</label>
            </div>
            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="biometricTermsEditable"
                formControlName="isEditable"
              />
              <label for="biometricTermsEditable">{{
                'general.isEditable' | translate | titlecase
              }}</label>
            </div>
          </div>
          <div class="col">
            <label class="form-label" id="bioMetricTermsCustom">{{
              'general.customDescription' | translate
            }}</label>

            <div class="row g-2">
              <div class="col-lg-6" *ngIf="availableLanguages['nl']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-nl"
                      role="img"
                      attr.aria-label="{{ 'wcag.nl' | translate }}"
                      id="flag-nl-id24"
                    ></span
                  ></span>

                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="bioMetricTermsCustom flag-nl-id24"
                    formControlName="title_nl"
                  />
                </div>
              </div>
              <div class="col-lg-6" *ngIf="availableLanguages['en']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-en"
                      role="img"
                      attr.aria-label="{{ 'wcag.en' | translate }}"
                      id="flag-en-id24"
                    ></span
                  ></span>
                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="bioMetricTermsCustom flag-en-id24"
                    formControlName="title_en"
                  />
                </div>
              </div>
              <div class="col-lg-6" *ngIf="availableLanguages['fr']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-fr"
                      role="img"
                      attr.aria-label="{{ 'wcag.fr' | translate }}"
                      id="flag-fr-id24"
                    ></span
                  ></span>

                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="bioMetricTermsCustom flag-fr-id24"
                    formControlName="title_fr"
                  />
                </div>
              </div>
              <div class="col-lg-6" *ngIf="availableLanguages['de']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-de"
                      role="img"
                      attr.aria-label="{{ 'wcag.de' | translate }}"
                      id="flag-de-id24"
                    ></span
                  ></span>
                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="bioMetricTermsCustom flag-de-id24"
                    formControlName="title_de"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </fieldset>
      <fieldset *ngIf="showUploadDocuments" formGroupName="documents"
        ><legend class="h4">{{ 'general.documents' | translate }}</legend>
        <div class="row gx-2 border-bottom mb-3 pb-2">
          <div class="col-lg-4">
            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="documentsVisible"
                checked
                formControlName="isVisible"
                (change)="onVisibleInputChange('documents')"
              />
              <label for="documentsVisible">{{
                'general.isVisible' | translate | titlecase
              }}</label>
            </div>
            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="documentsRequired"
                checked
                formControlName="isRequired"
              />
              <label for="documentsRequired">{{
                'general.isRequired' | translate | titlecase
              }}</label>
            </div>
            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="documentsEditable"
                formControlName="isEditable"
                disabled
              />
              <label for="documentsEditable">{{
                'general.isEditable' | translate | titlecase
              }}</label>
            </div>
          </div>
          <div class="col">
            <label class="form-label" id="documentsCustomLabel">{{
              'general.customDescription' | translate
            }}</label>

            <div class="row g-2">
              <div class="col-lg-6" *ngIf="availableLanguages['nl']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-nl"
                      role="img"
                      attr.aria-label="{{ 'wcag.nl' | translate }}"
                      id="flag-nl-id25"
                    ></span
                  ></span>

                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="documentsCustomLabel flag-nl-id25"
                    formControlName="title_nl"
                  />
                </div>
              </div>
              <div class="col-lg-6" *ngIf="availableLanguages['en']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-en"
                      role="img"
                      attr.aria-label="{{ 'wcag.en' | translate }}"
                      id="flag-en-id25"
                    ></span
                  ></span>
                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="documentsCustomLabel flag-en-id25"
                    formControlName="title_en"
                  />
                </div>
              </div>
              <div class="col-lg-6" *ngIf="availableLanguages['fr']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-fr"
                      role="img"
                      attr.aria-label="{{ 'wcag.fr' | translate }}"
                      id="flag-fr-id25"
                    ></span
                  ></span>

                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="documentsCustomLabel flag-fr-id25"
                    formControlName="title_fr"
                  />
                </div>
              </div>
              <div class="col-lg-6" *ngIf="availableLanguages['de']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-de"
                      role="img"
                      attr.aria-label="{{ 'wcag.de' | translate }}"
                      id="flag-de-id25"
                    ></span
                  ></span>
                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="documentsCustomLabel flag-de-id25"
                    formControlName="title_de"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </fieldset>

      <fieldset *ngIf="showProfilePicture" formGroupName="profilePicture">
        <legend class="h4">{{ 'general.profilePicture' | translate }}</legend>
        <div class="row gx-2 border-bottom mb-3 pb-2">
          <div class="col-lg-4">
            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="profilePictureVisible"
                checked
                formControlName="isVisible"
                (change)="onVisibleInputChange('profilePicture')"
              />
              <label for="profilePictureVisible">{{
                'general.isVisible' | translate | titlecase
              }}</label>
            </div>
            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="profilePictureRequired"
                checked
                formControlName="isRequired"
              />
              <label for="profilePictureRequired">{{
                'general.isRequired' | translate | titlecase
              }}</label>
            </div>
            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="profilePictureEditable"
                formControlName="isEditable"
                disabled
              />
              <label for="profilePictureEditable">{{
                'general.isEditable' | translate | titlecase
              }}</label>
            </div>
          </div>
          <div class="col">
            <label class="form-label" id="profilePictureCustom">{{
              'general.customDescription' | translate
            }}</label>

            <div class="row g-2">
              <div class="col-lg-6" *ngIf="availableLanguages['nl']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-nl"
                      role="img"
                      attr.aria-label="{{ 'wcag.nl' | translate }}"
                      id="flag-nl-id26"
                    ></span
                  ></span>

                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="profilePictureCustom flag-nl-id26"
                    formControlName="title_nl"
                  />
                </div>
              </div>
              <div class="col-lg-6" *ngIf="availableLanguages['en']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-en"
                      role="img"
                      attr.aria-label="{{ 'wcag.en' | translate }}"
                      id="flag-en-id26"
                    ></span
                  ></span>
                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="profilePictureCustom flag-en-id26"
                    formControlName="title_en"
                  />
                </div>
              </div>
              <div class="col-lg-6" *ngIf="availableLanguages['fr']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-fr"
                      role="img"
                      attr.aria-label="{{ 'wcag.fr' | translate }}"
                      id="flag-fr-id26"
                    ></span
                  ></span>

                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="profilePictureCustom flag-fr-id26"
                    formControlName="title_fr"
                  />
                </div>
              </div>
              <div class="col-lg-6" *ngIf="availableLanguages['de']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-de"
                      role="img"
                      attr.aria-label="{{ 'wcag.de' | translate }}"
                      id="flag-de-id26"
                    ></span
                  ></span>
                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="profilePictureCustom flag-de-id26"
                    formControlName="title_de"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </fieldset>

      <fieldset formGroupName="status">
        <legend class="h4">{{ 'general.status' | translate }}</legend>
        <div class="row gx-2 border-bottom mb-3 pb-2">
          <div class="col-lg-4">
            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="statusVisible"
                checked
                formControlName="isVisible"
                (change)="onVisibleInputChange('status')"
              />
              <label for="statusVisible">{{
                'general.isVisible' | translate | titlecase
              }}</label>
            </div>
            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="statusRequired"
                checked
                formControlName="isRequired"
              />
              <label for="statusRequired">{{
                'general.isRequired' | translate | titlecase
              }}</label>
            </div>
            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="statusEditable"
                formControlName="isEditable"
              />
              <label for="statusEditable">{{
                'general.isEditable' | translate | titlecase
              }}</label>
            </div>
          </div>
          <div class="col">
            <label class="form-label" id="statusCustomLabel">{{
              'general.customDescription' | translate
            }}</label>

            <div class="row g-2">
              <div class="col-lg-6" *ngIf="availableLanguages['nl']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-nl"
                      role="img"
                      attr.aria-label="{{ 'wcag.nl' | translate }}"
                      id="flag-nl-id27"
                    ></span
                  ></span>

                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="statusCustomLabel flag-nl-id27"
                    formControlName="title_nl"
                  />
                </div>
              </div>
              <div class="col-lg-6" *ngIf="availableLanguages['en']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-en"
                      role="img"
                      attr.aria-label="{{ 'wcag.en' | translate }}"
                      id="flag-en-id27"
                    ></span
                  ></span>
                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="statusCustomLabel flag-en-id27"
                    formControlName="title_en"
                  />
                </div>
              </div>
              <div class="col-lg-6" *ngIf="availableLanguages['fr']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-fr"
                      role="img"
                      attr.aria-label="{{ 'wcag.fr' | translate }}"
                      id="flag-fr-id27"
                    ></span
                  ></span>

                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="statusCustomLabel flag-fr-id27"
                    formControlName="title_fr"
                  />
                </div>
              </div>
              <div class="col-lg-6" *ngIf="availableLanguages['de']">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-de"
                      role="img"
                      attr.aria-label="{{ 'wcag.de' | translate }}"
                      id="flag-de-id27"
                    ></span
                  ></span>
                  <input
                    type="text"
                    class="form-control"
                    aria-labelledby="statusCustomLabel flag-de-id27"
                    formControlName="title_de"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </fieldset>

      <div class="form-footer sticky-bottom">
        <button
          class="btn btn-primary"
          type="submit"
          [canSee]="[accessRights.Settings_write]"
          [canSee]="[accessRights.ConfigurationOptions_write]"
        >
          {{ 'general.save' | translate }}
        </button>
      </div>
    </div>
  </section>

  <!-- End Card -->
</form>

<registration-category-options-card
  [formValues]="regCategoryOptions$ | async"
  (onSubmit)="onFormSubmit($event)"
>
</registration-category-options-card>

<registration-category-filter-card
  [formValues]="regCategoryFilters$ | async"
  [regCategorieOptions$]="regCategoryOptions$"
  (onSubmit)="onFormSubmit($event)"
></registration-category-filter-card>

<notification-status-card
  [formValues]="{
    notifications: noticationAgreements$ | async,
    emailNewsletterAgreement: showNewslettersAgreements$ | async,
    emailOffersAgreement: showOffersAgreements$ | async
  }"
  (onSubmit)="onFormSubmit($event)"
></notification-status-card>

<section class="card mb-3">
  <div class="card-header card-collapse">
    <!-- Header -->
    <h2 class="accordion-header">
      <button
        class="accordion-button"
        type="button"
        [attr.aria-expanded]="isCollapsedMemberUrl ? 'false' : 'true'"
        (click)="isCollapsedMemberUrl = !isCollapsedMemberUrl"
        aria-controls="memberCategoriesExplanation"
      >
        <span class="fs-3">
          {{ 'general.memberCategoriesExplanation' | translate }}
        </span>

        <i
          class="fa fa-fw"
          [ngClass]="isCollapsedMemberUrl ? 'fa-chevron-down' : 'fa-chevron-up'"
          attr.aria-label="{{ 'wcag.toggleSection' | translate }}"
          role="img"
        ></i>
      </button>
    </h2>

    <!-- End Header -->
  </div>
  <div
    *ngIf="!isCollapsedMemberUrl"
    class="card-body"
    id="memberCategoriesExplanation"
  >
    <form
      [formGroup]="form2"
      (ngSubmit)="onSubmitMemberCategoryUrls(form2)"
      #formRef="ngForm"
      [patchForm]="valuesForm$ | async"
    >
      <fieldset class="mb-4">
        <legend class="form-label" id="mceUrlLabel">
          {{
            'configurationOptionModule.memberCategoriesURLExplanation'
              | translate
          }}</legend
        >
        <div class="row g-2 mb-3">
          <div class="col-lg-6" *ngIf="availableLanguages['nl']">
            <div class="input-group">
              <span class="input-group-text"
                ><span
                  class="flag flag-nl"
                  role="img"
                  attr.aria-label="{{ 'wcag.nl' | translate }}"
                  id="flag-nl-2"
                ></span
              ></span>

              <input
                type="text"
                id=""
                class="form-control"
                aria-labelledby="mceUrlLabel flag-nl-2"
                formControlName="nl_member_categories_page_url"
                placeholder="https://example.com"
              />
            </div>
          </div>
          <div class="col-lg-6" *ngIf="availableLanguages['en']">
            <div class="input-group">
              <span class="input-group-text"
                ><span
                  class="flag flag-en"
                  role="img"
                  attr.aria-label="{{ 'wcag.en' | translate }}"
                  id="flag-en-2"
                ></span
              ></span>
              <input
                type="text"
                aria-labelledby="mceUrlLabel flag-en-2"
                class="form-control"
                formControlName="en_member_categories_page_url"
                placeholder="https://example.com"
              />
            </div>
          </div>

          <div class="col-lg-6" *ngIf="availableLanguages['fr']">
            <div class="input-group">
              <span class="input-group-text"
                ><span
                  class="flag flag-fr"
                  role="img"
                  attr.aria-label="{{ 'wcag.fr' | translate }}"
                  id="flag-fr-2"
                ></span
              ></span>

              <input
                type="text"
                aria-labelledby="mceUrlLabel flag-fr-2"
                class="form-control"
                formControlName="fr_member_categories_page_url"
                placeholder="https://example.com"
              />
            </div>
          </div>
          <div class="col-lg-6" *ngIf="availableLanguages['de']">
            <div class="input-group">
              <span class="input-group-text"
                ><span
                  class="flag flag-de"
                  role="img"
                  attr.aria-label="{{ 'wcag.de' | translate }}"
                  id="flag-de-2"
                ></span
              ></span>
              <input
                type="text"
                aria-labelledby="mceUrlLabel flag-de-2"
                class="form-control"
                formControlName="de_member_categories_page_url"
                placeholder="https://example.com"
              />
            </div>
          </div>
        </div>
      </fieldset>
      <div class="form-footer">
        <button
          class="btn btn-primary"
          type="submit"
          [canSee]="[accessRights.Settings_write]"
          [canSee]="[accessRights.ConfigurationOptions_write]"
        >
          {{ 'general.save' | translate }}
        </button>
      </div>
    </form>
  </div>
</section>
